import { create } from "zustand";

type NavigationState = {
  next: string;
  remainTime: string;
};

const initialState: NavigationState = {
  next: "",
  remainTime: "",
};

export const useNavigation = create<NavigationState>(() => initialState);

export const navigationActions = {
  setNext(next: string) {
    useNavigation.setState({ next });
  },
  getNext(clearIt?: boolean): string {
    const state = useNavigation.getState();
    const next = state.next;

    if (clearIt) useNavigation.setState({ next: "" });

    return next;
  },
  setRemainTime(remainTime: string) {
    useNavigation.setState({ remainTime });
  },
  getRemainTime(): string {
    const state = useNavigation.getState();
    return state.remainTime;
  },
};
